export const Smarowidla = [
  {
    "id": "smarowidlo-1",
    "name": "Pasta z soczewicy czerwonej",
    "category": "SMAROWIDŁA",
    "shortDesc": "Pasta z soczewicy czerwonej z suszonymi pomidorami i pestkami dyni.",
    "fullDesc": "Pasta z soczewicy czerwonej to zdrowe i smaczne smarowidło, idealne na kanapki, dip do warzyw lub jako dodatek do innych potraw. Bogata w białko roślinne i zdrowe tłuszcze.",
    "image": "Smarowidla/pasta_z_soczewicy.jpg",

    "preparation": "Zmiel pestki dyni w młynku, następnie w blenderze połącz ugotowaną soczewicę, suszone pomidory w oleju oraz zmielone pestki dyni. Blenduj do uzyskania gładkiej pasty. Jeśli pasta jest zbyt gęsta, dodaj trochę oleju z suszonych pomidorów. Dopraw solą do smaku.",
    "ingredients": [
      "1 szklanka ugotowanej soczewicy czerwonej",
      "½ szklanki łuszczonych pestek z dyni",
      "150 g suszonych pomidorów w oleju z ziołami",
      "Ewentualnie: olej z suszonych pomidorów (do uzyskania pożądanej konsystencji)",
      "Sól (do smaku)"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-2",
    "name": "Czekoladowy krem z awokado",
    "category": "SMAROWIDŁA",
    "shortDesc": "Pyszny, zdrowy czekoladowy krem z awokado, idealny do chleba, tostów czy naleśników.",
    "fullDesc": "Czekoladowy krem z awokado to pyszna, zdrowa alternatywa dla tradycyjnych słodkich smarowideł. Gładki, kremowy i delikatnie czekoladowy, idealnie pasuje do chleba, tostów czy naleśników. Dzięki awokado, krem jest nie tylko pyszny, ale również pełen zdrowych tłuszczy. Słodycz miodu świetnie łączy się z intensywnym smakiem kakao, tworząc wyjątkową, naturalną przekąskę.",
    "image": "Smarowidla/smarowidlo.jpg",
    "preparation": "Przekrój awokado na pół, usuń pestkę i wydrąż miąższ. Włóż miąższ awokado do blendera. Dodaj kakao i miód. Miksuj składniki aż do uzyskania gładkiej, kremowej konsystencji. Dopasuj słodycz, dodając więcej miodu, jeśli chcesz. Przechowuj krem w lodówce, w szczelnie zamkniętym słoiczku, do kilku dni.",
    "ingredients": [
      "1 dojrzałe awokado",
      "2 łyżeczki kakao (lub więcej, wg gustu)",
      "2-3 łyżki miodu"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-3",
    "name": "Krem chałwowy",
    "category": "SMAROWIDŁA",
    "shortDesc": "Prosty i pyszny krem chałwowy z tahiny i miodu.",
    "fullDesc": "Krem chałwowy to prosty i pyszny smakołyk, który powstaje z połączenia tahiny i miodu. Jest to naturalna alternatywa dla tradycyjnych słodkich kremów, z nutą orzechowego smaku sezamu. Doskonale sprawdza się jako smarowidło do chleba, naleśników, lub jako dodatek do deserów.",
    "image": "Smarowidla/smarowidlo.jpg",
    "preparation": "Wymieszaj tahinę z miodem w proporcjach według własnego gustu, dostosowując ilość miodu do pożądanej słodyczy. Dokładnie wymieszaj, aż uzyskasz gładką, kremową konsystencję. Smacznego!",
    "ingredients": [
      "Tahina (pasta sezamowa)",
      "Miód"
    ].join("\n"),
    "path": "smarowidla"
  },
  
  {
    "id": "smarowidlo-4",
    "name": "Pasta do chleba z zielonej soczewicy i orzechów włoskich",
    "category": "SMAROWIDŁA",
    "shortDesc": "Pyszna pasta do chleba o smaku domowego pasztetu, z zieloną soczewicą i orzechami włoskimi.",
    "fullDesc": "Ta pasta do chleba z zielonej soczewicy i orzechów włoskich smakuje jak domowy pasztet mięsny! Dzięki połączeniu soczewicy i orzechów, ma pełny, bogaty smak i kremową konsystencję. Cebula i przyprawy dodają głębi, a całość idealnie komponuje się na kanapkach. To świetna alternatywa dla mięsnych past, pełna białka i zdrowych tłuszczy! Przepis inspirowany przez Beszamel.",
    "image": "Smarowidla/smarowidlo.jpg",
    "preparation": "Cebulę pokrój w kostkę i poddusź na rosole, aż zmięknie.\nPołącz duszoną cebulę z ugotowaną soczewicą, zmielonymi orzechami, olejem i przyprawami.\nZmiksuj całość blenderem na gładką masę.\n(Opcjonalnie) Dodaj przecier pomidorowy, jeśli chcesz wzbogacić smak, ale nie jest to konieczne.\nSmacznego!",
    "ingredients": [
      "1 szklanka ugotowanej zielonej soczewicy",
      "100 g zmielonych orzechów włoskich",
      "2 średnie cebule",
      "1/2 szklanki rosołu (do podduszenia cebuli)",
      "1 łyżeczka majeranku",
      "1 łyżeczka tymianku",
      "Szczypta gałki muszkatołowej",
      "Sól i pieprz do smaku"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-5",
    "name": "Kakaowy krem z daktyli i nerkowców",
    "category": "SMAROWIDŁA",
    "shortDesc": "Zdrowy, kakaowy krem z daktyli i nerkowców, idealny na kanapki i zdrową przekąskę.",
    "fullDesc": "Kakaowy krem z daktyli i nerkowców to pyszna, zdrowa alternatywa dla tradycyjnych smarowideł. Daktyle dodają mu naturalnej słodyczy, a orzechy nerkowca wprowadzają gładką, aksamitną konsystencję. Gorzka czekolada w postaci kakao wprowadza głęboki smak, tworząc idealnie zbalansowaną masę. Doskonały na kanapki, ale również jako zdrowa przekąska, którą można zajadać prosto ze słoiczka!",
    "image": "Smarowidla/smarowidlo.jpg",
    "preparation": "Daktyle zalej zimną wodą i pozostaw na noc do namoczenia.\nOrzechy nerkowca mocz przez 2-4 godziny w zimnej, przegotowanej wodzie.\nPo odpowiednim namoczeniu daktyli i orzechów, przełóż je do blendera, dodaj kakao i miksuj na wysokich obrotach przez kilka minut, robiąc przerwy, aby nie przegrzać blendera.\nBlenduj, aż uzyskasz jednolitą, gładką i aksamitną konsystencję.\nPodawaj z pieczywem lub jedz samodzielnie – tak czy inaczej, krem jest wyśmienity!",
    "ingredients": [
      "1 szklanka daktyli",
      "1 szklanka orzechów nerkowca",
      "1 kopiasta łyżka gorzkiego, dobrego kakao"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-6",
    "name": "Hummus - Pasta z ciecierzycy",
    "category": "SMAROWIDŁA",
    "shortDesc": "Klasyczny hummus z ciecierzycy, tahini, oliwą i cytryną, z aromatem czosnku i kminu.",
    "fullDesc": "Hummus to klasyczna pasta z ciecierzycy, której podstawowe składniki to ciecierzyca, tahini, oliwa z oliwek i sok z cytryny. Kmin i czosnek nadają jej wyjątkowego smaku, a czarnuszka doskonale podkreśla jej smak przy podaniu. Hummus świetnie sprawdza się jako dip do warzyw, smarowidło do chleba lub dodatek do sałatek. Prosty, pyszny i pełen zdrowych składników!",
    "image": "Smarowidla/hummus.jpg",
    "preparation": "Namaczanie ciecierzycy: Ciecierzycę namaczamy przez kilka godzin w wodzie z łyżeczką sody oczyszczonej. Następnie gotujemy ją w świeżej wodzie z łyżeczką sody oczyszczonej, aż będzie miękka.\nPrzygotowanie hummusu: Czosnek poszatkuj lub przeciśnij przez praskę. Wszystkie składniki (oprócz czarnuszki) umieść w blenderze: ugotowaną ciecierzycę, sok z cytryny, tahini, oliwę, ciepłą wodę, czosnek, kmin i sól.\nBlendowanie: Miksuj wszystkie składniki na gładką masę.\nPodanie: Podawaj hummus posypany czarnuszką.\nSmacznego!",
    "ingredients": [
      "1 duża szklanka ugotowanej ciecierzycy",
      "2 łyżki soku z cytryny",
      "3 łyżki pasty tahini",
      "3 łyżki oliwy z oliwek",
      "3 łyżki ciepłej wody",
      "1 ząbek czosnku",
      "Duża szczypta kminu",
      "Sól do smaku",
      "Czarnuszka do podania"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-7",
    "name": "Serek truskawkowy z nerkowców – jak homogenizowany",
    "category": "SMAROWIDŁA",
    "shortDesc": "Pyszny, kremowy serek truskawkowy z nerkowców, idealny na kanapki i jako zdrowy deser.",
    "fullDesc": "Serek truskawkowy z nerkowców to pyszna, kremowa alternatywa dla tradycyjnych serków twarogowych. Nerkowce nadają mu aksamitną konsystencję, a truskawki wprowadzają naturalną słodycz i owocowy smak. Miód dodaje subtelnej słodyczy, tworząc idealną kompozycję. Doskonały jako smarowidło na kanapki, dodatek do naleśników, a także jako zdrowy deser. To przepyszna opcja pełna zdrowych tłuszczy i witamin!",
    "image": "Smarowidla/smarowidlo.jpg",
    "preparation": "Nerkowce namocz w wodzie najlepiej na noc, a następnie odlej wodę.\nZblenduj orzechy z truskawkami i miodem na gładką, kremową masę.\nSmacznego!",
    "ingredients": [
      "250 g nerkowców",
      "1,5 szklanki truskawek",
      "Miód – do smaku"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-8",
    "name": "Czekoladowy krem z fasolki adzuki",
    "category": "SMAROWIDŁA",
    "shortDesc": "Pyszny czekoladowy krem z fasolki adzuki, idealny na kanapki, naleśniki i desery.",
    "fullDesc": "Czekoladowy krem z fasolki adzuki to pyszna i zdrowa alternatywa dla tradycyjnych kremów czekoladowych. Fasolka adzuki, popularna w kuchni japońskiej, nadaje kremowi delikatną, lekko orzechową nutę. W połączeniu z kakao i miodem tworzy gładką, słodką masę, która doskonale sprawdza się jako smarowidło do chleba, naleśników, czy jako dodatek do deserów. To japońska inspiracja, która łączy tradycyjne składniki z nowoczesnym smakiem!",
    "image": "Smarowidla/smarowidlo.jpg",
    "preparation": "Ugotowaną fasolkę adzuki zblenduj razem z kakao i miodem na jednolitą masę.\nSmacznego!",
    "ingredients": [
      "1 szklanka ugotowanej fasolki adzuki",
      "1 łyżka kakao",
      "3 łyżki miodu"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-9",
    "name": "Fava – Pasta z grochu",
    "category": "SMAROWIDŁA",
    "shortDesc": "Pyszna pasta z grochu żółtego, cytryną i duszoną cebulą, idealna na kanapki i jako dip.",
    "fullDesc": "Fava to wyjątkowa pasta z grochu, której smak w dużej mierze zależy od delikatnej cebuli duszonej w rosole lub wodzie. Po połączeniu z oliwą i cytryną powstaje kremowa, jedwabista masa, która jest idealna jako smarowidło lub dodatek do potraw. Ten przepis inspirowany Olgą Smile to pyszna, aromatyczna alternatywa dla tradycyjnych past, doskonała na kanapki lub jako dip.",
    "image": "Smarowidla/smarowidlo.jpg",
    "preparation": "Namaczanie grochu: Groch namocz dzień wcześniej. Następnie wymień wodę i ugotuj go (bez solenia) w świeżej wodzie z liśćmi laurowymi, aż będzie miękki.\nDuszenie cebuli: Cebule pokrój w drobną kostkę, posól i przełóż do rondla. Dodaj ½ szklanki rosołu lub wody i duś na małym ogniu, aż cebula stanie się miękka i szklista.\nBlendowanie: Ugotowany groch połącz z duszoną cebulą, dodaj oliwę i sok z cytryny. Zblenduj wszystko razem na gładką, jedwabistą masę.\nPodanie: Podawaj pastę z tymiankiem posypanym na wierzchu.\nSmacznego!",
    "ingredients": [
      "½ szklanki suchego grochu żółtego",
      "3-5 dużych białych cebul",
      "1 cytryna",
      "5 listków laurowych",
      "200 ml oliwy",
      "½ szklanki rosołu lub wody",
      "Sól do smaku",
      "Tymianek do podania"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-10",
    "name": "Pasta rogalowa",
    "category": "SMAROWIDŁA",
    "shortDesc": "Pyszne smarowidło z uprażonym sezamem i makiem, idealne na świeżym pieczywie.",
    "fullDesc": "Pasta rogalowa to pyszne i zdrowe smarowidło inspirowane przepisem z bloga Jadłonomia. Połączenie uprażonego sezamu i maku z kremową fasolą tworzy wyjątkowy smak i teksturę. Idealna na śniadanie lub jako przekąska.",
    "image": "Smarowidla/smarowidlo.jpg",
    "preparation": "Prażenie nasion: Upraż sezam i mak na suchej patelni, aż staną się lekko złociste i uwolnią aromat.\nBlendowanie: W blenderze umieść ugotowaną fasolę, olej, sól i pieprz. Miksuj do uzyskania gładkiej masy.\nDodanie wody: Stopniowo dodawaj wodę, kontynuując blendowanie, aż pasta osiągnie pożądaną konsystencję.\nDodanie nasion: Przełóż pastę do miski i wymieszaj z uprażonymi nasionami sezamu i maku.\nPodanie: Podawaj pastę na świeżym pieczywie, posypaną dodatkową porcją uprażonych nasion.\nSmacznego!",
    "ingredients": [
      "3 łyżki uprażonego sezamu",
      "3 łyżki uprażonego maku",
      "1,5 szklanki ugotowanej fasoli białej",
      "2-3 łyżki oleju roślinnego",
      "Szczypta soli i świeżo mielonego czarnego pieprzu",
      "2-3 łyżki wody"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-11",
    "name": "Krem czekoladowy z banana",
    "category": "SMAROWIDŁA",
    "shortDesc": "Zdrowy krem czekoladowy z banana, idealny na kanapki, tosty i owsiankę.",
    "fullDesc": "Ten prosty krem czekoladowy z banana to pyszna, zdrowa alternatywa dla tradycyjnych słodkich smarowideł. Banany nadają mu naturalną słodycz, a kakao wprowadza głęboki czekoladowy smak. Idealny do smarowania chleba, tostów czy jako dodatek do owsianki. Szybki, łatwy i pełen smaku!",
    "image": "Smarowidla/smarowidlo.jpg",
    "preparation": "Obierz banana i pokrój na kawałki.\nZblenduj banana z kakao na jednolitą masę.\nSmacznego!",
    "ingredients": [
      "1 banan",
      "1 łyżka kakao"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-12",
    "name": "Pasta z czerwonej fasoli",
    "category": "SMAROWIDŁA",
    "shortDesc": "Szybka pasta z czerwonej fasoli z oliwą, papryką i oregano, idealna na kanapki.",
    "fullDesc": "Pasta z czerwonej fasoli to szybkie i smaczne smarowidło, idealne na kanapki czy jako dip do warzyw. Jej przygotowanie jest proste i szybkie, a smak można dostosować do własnych preferencji poprzez modyfikację ilości przypraw. Przepis pochodzi z bloga Jadłonomia, który inspiruje do zdrowego gotowania.",
    "image": "Smarowidla/pasta_fasolowa.jpg",
    "preparation": "Namaczanie i gotowanie fasoli: Jeśli używasz suchej fasoli, namocz ją przez kilka godzin lub całą noc. Następnie ugotuj w świeżej wodzie do miękkości. Jeśli masz ugotowaną fasolę, przejdź do kolejnego kroku.\nBlendowanie: W misce połącz ugotowaną fasolę, oliwę z oliwek, słodką paprykę, oregano, ostrą paprykę, sól i pieprz. Użyj blendera ręcznego lub kielichowego, aby zmiksować składniki na gładką masę.\nDoprawianie: Spróbuj pasty i w razie potrzeby dostosuj przyprawy do własnego smaku.\nPodanie: Podawaj pastę na świeżym pieczywie, posypaną świeżymi ziołami lub dodatkowymi przyprawami według uznania.\nSmacznego!",
    "ingredients": [
      "½ szklanki suchej czerwonej fasoli lub 1 szklanka ugotowanej czerwonej fasoli",
      "3-4 łyżki oliwy z oliwek",
      "1 łyżeczka słodkiej papryki",
      "½ łyżeczki oregano",
      "Szczypta ostrej papryki",
      "Sól i pieprz do smaku"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-13",
    "name": "Pasta świąteczna",
    "category": "SMAROWIDŁA",
    "shortDesc": "Aromatyczna pasta świąteczna z jajkami, pieczarkami, cebulą i majonezem.",
    "fullDesc": "Pasta świąteczna to pyszne, aromatyczne smarowidło, które kojarzy się z atmosferą świąt. Dzięki połączeniu jajek, pieczarek, cebuli i majonezu, ma wyjątkowy, domowy smak, który wprowadza do kuchni nutę świątecznego ciepła. Idealna na kanapki, wędliny, a także jako dodatek do potraw wigilijnych. Smakuje jak święta!",
    "image": "Smarowidla/smarowidlo.jpg",
    "preparation": "Gotowanie jajek: Jajka ugotuj na twardo. Po ostudzeniu pokrój w kosteczkę.\nPrzygotowanie pieczarek i cebuli: Pieczarki i cebulę pokrój w drobną kostkę. Przełóż je do garnka i dusz na rosole lub wodzie, aż staną się miękkie. Dopraw solą i pieprzem do smaku.\nŁączenie składników: Po ostudzeniu pieczarki i cebulę połącz z jajkami. Dodaj majonez, wymieszaj wszystko, aż składniki się połączą.\nDoprawianie: W razie potrzeby dopraw solą i pieprzem do smaku.\nSmacznego!",
    "ingredients": [
      "Jajka",
      "Pieczarki",
      "Cebula",
      "1 szklanka rosołu lub wody",
      "Majonez",
      "Sól i pieprz do smaku"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-14",
    "name": "Pasta jajeczna",
    "category": "SMAROWIDŁA",
    "shortDesc": "Prosta i szybka pasta jajeczna z majonezem, idealna na kanapki.",
    "fullDesc": "Prosta i szybka pasta jajeczna to klasyka, która zawsze smakuje wyśmienicie. Dzięki majonezowi, pasta jest kremowa i pełna smaku. Idealna na kanapki z szynką.",
    "image": "Smarowidla/pasta_jajeczna.jpg",
    "preparation": "Gotowanie jajek: Jajka ugotuj na twardo, po czym ostudź.\nPrzygotowanie pasty: Pokrój jajka w kosteczkę (dla leniwych, można je po prostu ugnieść rękami lub widelcem).\nŁączenie składników: Do jajek dodaj majonez, sól i pieprz. Wszystko dokładnie wymieszaj.\nSmacznego!",
    "ingredients": [
      "Jajka",
      "Majonez",
      "Sól i pieprz do smaku"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-15",
    "name": "Pasta z tuńczyka",
    "category": "SMAROWIDŁA",
    "shortDesc": "Szybka i smaczna pasta z tuńczyka, idealna na kanapki, sałatki i jako dodatek do warzyw.",
    "fullDesc": "Pasta z tuńczyka to szybka i smaczna przekąska, idealna na kanapki, do sałatek lub jako dodatek do warzyw. Dzięki tuńczykowi, kukurydzy i cebuli, ma świeży, lekko słodkawy smak, który doskonale komponuje się z majonezem. Prosta w przygotowaniu i pełna smaku!",
    "image": "Smarowidla/smarowidlo.jpg",
    "preparation": "Przygotowanie składników: Otwórz puszkę tuńczyka i odsącz nadmiar sosu. Odsącz również kukurydzę. Cebulę czerwoną pokrój w drobną kostkę i posól, aby zmiękła.\nŁączenie składników: W misce połącz tuńczyka, kukurydzę, cebulę oraz majonez.\nDoprawianie: Dopraw solą i pieprzem do smaku, dokładnie wymieszaj.\nSmacznego!",
    "ingredients": [
      "1 puszka tuńczyka w sosie własnym",
      "1 słoik kukurydzy",
      "1 cebula czerwona",
      "Majonez",
      "Sól i pieprz do smaku"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-16",
    "name": "Pasta z gotowanego indyka",
    "category": "SMAROWIDŁA",
    "shortDesc": "Pyszna i zdrowa pasta z gotowanego indyka, idealna na kanapki.",
    "fullDesc": "Pasta z gotowanego indyka to pyszna i zdrowa alternatywa dla sklepowych wędlin. Dzięki mięsu z indyka, cebuli i opcjonalnej kukurydzy, pasta ma lekką, kremową konsystencję i pełny smak, który zadowoli każdego. Idealna na kanapki, szczególnie z ogórkiem. Jest to doskonały sposób na przygotowanie zdrowej, domowej pasty, pełnej białka i smaku!",
    "image": "Smarowidla/pasta_z_gotowanego.jpg",
    "preparation": "Przygotowanie mięsa: Mięso oddziel od kości i pokrój w kostkę lub rozdrobnij widelcem.\nPrzygotowanie cebuli: Cebulę pokrój w drobną kostkę, posól, aby zmiękła i puściła sok.\nŁączenie składników: W misce połącz mięso, cebulę, odsączoną kukurydzę (jeśli używasz) oraz majonez.\nDoprawianie: Dopraw pastę solą i pieprzem do smaku, dokładnie wymieszaj.\nSmacznego!",
    "ingredients": [
      "Mięso z indyka (z wywaru, mogą być skrzydełka lub golonka)",
      "Kukurydza w słoiku (opcjonalnie)",
      "Cebula",
      "Majonez",
      "Sól i pieprz do smaku"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-17",
    "name": "Dżem jabłkowy",
    "category": "SMAROWIDŁA",
    "shortDesc": "Pyszny, zdrowy dżem jabłkowy z cynamonem, idealny na kanapki i do wypieków.",
    "fullDesc": "Dżem jabłkowy to pyszny, domowy przysmak, który łączy naturalną słodycz jabłek z aromatem cynamonu. Idealny do kanapek czy jako dodatek do wypieków. Dzięki użyciu ksylitolu lub cukru kokosowego, jest to zdrowsza wersja tradycyjnego dżemu. Przepis inspirowany przez 'Healthy Plan by Ann' Ani Lewandowskiej, zachęca do wykorzystania naturalnych składników, które nadają mu wyjątkowy smak i zdrowotne właściwości.",
    "image": "Smarowidla/smarowidlo.jpg",
    "preparation": "Przygotowanie jabłek: Umyj jabłka, przekrój je na pół i usuń pestki. Zetrzyj je na małej tarce.\nGotowanie: Przenieś starte jabłka na patelnię, dodaj cynamon oraz ksylitol lub cukier. Dodaj odrobinę wody, aby jabłka się nie przypaliły.\nDuszenie: Duś jabłka przez około 20 minut pod przykryciem, mieszając od czasu do czasu, aż jabłka staną się miękkie i zacznie powstawać gęsta masa.\nPrzechowywanie: Przełóż gorący dżem do wyparzonych słoiczków i mocno zakręć.\nSmacznego!",
    "ingredients": [
      "1 kg jabłek (np. antonówek)",
      "1 łyżka cynamonu",
      "Woda",
      "Ksylitol lub inna forma cukru (trzcinowy lub kokosowy) (ilość wedle uznania, w zależności od słodkości jabłek)"
    ].join("\n"),
    "path": "smarowidla"
  },

  {
    "id": "smarowidlo-18",
    "name": "Pasta szprotkowa",
    "category": "SMAROWIDŁA",
    "shortDesc": "Prosta pasta szprotkowa z majonezem, idealna na kanapki i tostów.",
    "fullDesc": "Pasta szprotkowa to pyszne i proste smarowidło, które świetnie sprawdzi się na kanapkach, tostach czy jako dodatek do sałatek. Szprotki w oleju nadają paście wyjątkowego, rybnego smaku, a majonez sprawia, że pasta jest gładka i kremowa. Opcjonalnie, dla bardziej wyrazistego smaku, możesz dodać ketchup. To szybkie i smaczne rozwiązanie, idealne na każdą okazję.",
    "image": "Smarowidla/pasta_szprotkowa.jpg",
    "preparation": "1. Olej ze szprotek odlej, a same szprotki przełóż do miski i rozdrobnij widelcem, aż uzyskasz jednolitą konsystencję.\n2. Pół małej białej cebulki pokrój w drobną kosteczkę. Połóż na rozdrobnionych szprotkach i sypnij szczyptą soli, co złagodzi ostrość cebuli i wydobędzie naturalną słodycz.\n3.Dodaj majonez i dokładnie wymieszaj, aż pasta stanie się jednolita.\n4. Jeśli chcesz, możesz dodać odrobinę ketchupu, by nadać paście bardziej wyrazisty smak.\n5. Wymieszaj wszystko dokładnie, ewnrualnie dopraw solą oraz pieprzem i gotowe!\nSmacznego!",
    "ingredients": [
      "1 słoik szprotek w oleju ok. 250g",
      "Pół małej białej cebulki",
      "Szczypta soli",
      "1-2 łyżki majonezu",
      "Opcjonalnie: ketchup (opcjonalnie), więcej soli i pieprz",
    ].join("\n"),
    "path": "smarowidla"
  },
  
  
  
  
  
  
  
  
  
  
  
  
  
  
 
]

export default Smarowidla;
